import OperatorCareersHelper from "../../Components/Careers/Index";

const OperatorCareersPage = () => {
  return <OperatorCareersHelper />;
};

export default OperatorCareersPage;
